module.exports = __webpack_public_path__ + "img/52_19.861fb496.png";